module.exports = __webpack_public_path__ + "static/exclamation-mark-circle-red.21a739be13628c3db9d9e44efa239dca.svg";